const normalizeRole = (role: string) => role.trim().toLowerCase();

export const parseRoles = (roleString?: string | null) => {
  if (!roleString) {
    return [];
  }

  return roleString
    .split(',')
    .map(normalizeRole)
    .filter(Boolean);
};

export const hasRole = (roleString: string | null | undefined, role: string) => {
  const normalizedRole = normalizeRole(role);
  return parseRoles(roleString).includes(normalizedRole);
};

export const hasAnyRole = (roleString: string | null | undefined, roles: string[]) => {
  const userRoles = parseRoles(roleString);
  return roles.some((role) => userRoles.includes(normalizeRole(role)));
};

export const hasAdminSiteAccess = (roleString: string | null | undefined) => {
  return hasAnyRole(roleString, ['Lead', 'Admin', 'BrandAdmin']);
};
